module.exports = __webpack_public_path__ + "static/media/5.93568bf1.jpg";